import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SBUBUMapArrayModel, SBUBUMapModel } from "../../models/SBUBUMapModel";

const initialState: SBUBUMapArrayModel = {
  all_sbu_bu_Map: [],
  isSBUBUMapsFetching: false,
};
const SBUBUMapSlice = createSlice({
  name: "SBUBUMap",
  initialState: initialState,
  reducers: {
    setSBUBUMap(state, action: PayloadAction<SBUBUMapModel[]>) {
      state.all_sbu_bu_Map = action.payload;
    },
    setIsSBUBUMapsFetching(state, action: PayloadAction<boolean>) {
      state.isSBUBUMapsFetching = action.payload;
    },
  },
});
export default SBUBUMapSlice;
